export default __webpack_public_path__ + "static/media/1998.22964020.png";